// src/pages/Settings.jsx
import { useEffect, useState } from 'react';
import { api } from '../lib/api.js';

export default function Settings() {
  const [settings, setSettings] = useState([]);
  const [error, setError] = useState('');
  const [saved, setSaved] = useState(null);

  async function load() {
    try {
      const body = await api('/admin/settings');
      setSettings(body.settings);
    } catch (err) {
      setError(err.message);
    }
  }

  useEffect(() => { load(); }, []);

  async function save(key, value) {
    try {
      await api(`/admin/settings/${key}`, { method: 'PATCH', body: JSON.stringify({ value }) });
      setSaved(key);
      setTimeout(() => setSaved(null), 1500);
      load();
    } catch (err) {
      setError(err.message);
    }
  }

  return (
    <div className="p-8 max-w-2xl mx-auto">
      <h1 className="text-xl font-semibold text-charcoal">Settings</h1>
      <p className="text-xs text-ink/50 mt-1">System-wide values used by the case engine and alerting — changes take effect immediately, no restart needed.</p>

      {error && <p className="mt-3 text-sm text-p1">{error}</p>}

      <div className="mt-5 space-y-3">
        {settings.map((s) => (
          <SettingRow key={s.setting_key} setting={s} onSave={save} justSaved={saved === s.setting_key} />
        ))}
      </div>
    </div>
  );
}

function SettingRow({ setting, onSave, justSaved }) {
  const [value, setValue] = useState(setting.setting_value);
  return (
    <div className="rounded-lg border border-ink/10 bg-white p-4 flex items-center justify-between gap-4">
      <div className="min-w-0">
        <div className="text-sm font-mono text-charcoal">{setting.setting_key}</div>
        {setting.description && <div className="text-xs text-ink/50 mt-0.5">{setting.description}</div>}
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <input
          value={value} onChange={(e) => setValue(e.target.value)}
          className="w-32 rounded-md border border-ink/20 px-2.5 py-1.5 text-sm font-mono text-right"
        />
        <button
          onClick={() => onSave(setting.setting_key, value)}
          className="text-xs rounded-md bg-ink text-white px-3 py-1.5 hover:bg-ink-700"
        >
          {justSaved ? '✓ Saved' : 'Save'}
        </button>
      </div>
    </div>
  );
}
